
export const STORY_LENGTHS = ["short", "medium", "long", "natural"] as const;

export const STORY_LENGTH_LIMITS = {
  short: 10,
  medium: 25,
  long: 50,
  natural: 100 // Upper limit for context management, not a forced ending
};

export const GENRES = [
  "kidsStory",
  "fantasy",
  "romance",
  "adventure",
  "contemporary",
  "historicalFiction",
  "scienceFiction",
  "mystery",
  "horror",
  "superhero",
  "thriller"
] as const;

export const ENVIRONMENTS = [
  "urbanCity",
  "medievalCastle",
  "spaceStation",
  "forest",
  "desert",
  "ocean",
  "mountain",
  "smallTown",
  "futuristicMetropolis",
  "underwaterKingdom",
  "hauntedMansion"
] as const;
